// 「問い合わせカテゴリ」のその他を選択した時のテキストエリア(ユーザー向け)

function content(v: string) {
  switch (v) {
    case '応募確認メールが届かない':
      return '【必須】応募先店舗名：'
    case '電話番号の変更':
      return '【必須】応募先店舗名：\n【必須】応募日：\n【必須】生年月日：\n【必須】変更後の電話番号：'
    case 'メールアドレスの変更':
      return '【必須】応募先店舗名：\n【必須】応募日：\n【必須】生年月日：\n【必須】変更後のメールアドレス：'
    case 'システムエラーに関するお問い合わせ':
      return '問題解決のため可能な範囲でご入力をお願いいたします。\n■問題が発生した画面のURL(もしくは詳細)：\n■問題発生日時：●月●日●●時●●分頃\n■操作手順：\n■ご利用の端末(パソコン/スマートフォン/携帯電話/他)：\n■(パソコンをご利用の場合) ご利用のブラウザとバージョン情報：\n■(携帯端末をご利用の場合) 携帯電話会社(docomo/softbank/au/他)：\n■(携帯端末をご利用の場合) 機種名 (iPhone5など)：\n\n■その他：\n画面にエラーメッセージが表示される場合には、ご入力ください。'
    case 'キャンペーンについて':
      return '【必須】応募先店舗名：\n【必須】キャンペーンの種類：\n（例：バイト生活応援キャンペーン）\n【必須】問い合わせ内容：'
    case 'メールの配信停止・退会':
      return '【任意】メールアドレス：\n※連絡先メールアドレスと異なる場合\n【必須】希望される方に丸をつけてください\n　【　　】メール配信停止\n　【　　】退会'
    default:
      return ''
  }
}

export function displayCategoryTextarea() {
  const askCategory = document.getElementById('js-ask-category') as HTMLSelectElement
  const askContent = document.getElementById('js-ask-content') as HTMLTextAreaElement
  if (askCategory === null || askContent === null) return

  askCategory.addEventListener('change', (e) => {
    askContent.value = content((e.currentTarget as HTMLSelectElement).value)
  })
}
